import { useEffect } from 'react'
import { useSearchParams } from '@codeleap/web'
import { navigationEvents } from '@/config'

export type UseQueryParamsReturn<T> = [
  T,
  (params: T | null) => void,
]

// Same hook as useSearchParams but listens to URL changes made outside of React (e.g., browser back/forward buttons)
export function useQueryParams<T extends Record<string, string> = Record<string, string>>(): UseQueryParamsReturn<T> {
  const [params, setParams] = useSearchParams<T>()

  useEffect(() => {
    const handleUrlChange = () => {
      const searchParams = new URLSearchParams(window.location.search)
      const newParams = Object.fromEntries(searchParams) as T
      setParams(newParams)
    }

    window.addEventListener(navigationEvents.urlChange, handleUrlChange)
    window.addEventListener('popstate', handleUrlChange)

    return () => {
      window.removeEventListener(navigationEvents.urlChange, handleUrlChange)
      window.removeEventListener('popstate', handleUrlChange)
    }
  }, [setParams])

  return [params, setParams]
}

